<div class="edit-customer-root">
  <div class="edit-customers-header">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{
          customerHeaderInfo.tenantName
          ? customerHeaderInfo.tenantName
          : ('COMMON.NO_NAME' | translate)
          }}
        </div>
        <div class="slrn">
          {{ customerHeaderInfo.slrn ? customerHeaderInfo.slrn : ('COMMON.NO_SLRN' | translate) }}
        </div>
        <div class="row info-row">
          <div class="green-status v-2" *ngIf="customer.buildingType">{{ 'COMMON.BUILDING_TYPE.' + customer.buildingType
            | uppercase | translate }}</div>
          <div class="status v-2" [ngClass]="{
            'green-status': isComplete(),
            'dark-red-status': isRejected(),
            'gray-status': isPending(),
            'orange-status': isAssigned()
          }">

            {{ getCustomerStatusTranslationKey() | translate }}

          </div>

          <div *ngIf="customer.id" [ngClass]="{
                'dark-green-status': !customer.isNew,
                'green-status': customer.isNew }" class="v-2">
            {{ customer.isNew ? ('COMMON.NEW_ENTRY' | translate) : ('COMMON.EXISTING' | translate) }}
          </div>
        </div>
      </div>
      <div class="user-address">
        <div>{{ customerHeaderInfo?.email | hasValue }}</div>
        <div>{{ customerHeaderInfo?.phoneNumber | hasValue }}</div>
        <div>{{ customerHeaderInfo?.physicalAddress | hasValue }}</div>
      </div>
    </div>
    <div class="action-buttons" *ngIf="!onlyView">
      <button class="btn btn-header" (click)="regularize()"
        *ngIf="customer.accountNumber == ''&& customer.isNew && isRegularizationUploadVisible && permissionsService.isCustomerRegularizationAllowed">
        {{'CUSTOMER_DETAILS.REGULARIZE' | translate}}
      </button>
      <button class="btn btn-header" data-bs-toggle="modal"
        (click)="getMobileUsers(); setModalType(AssetAssignType.Retagged);" data-bs-target="#assignToFieldAgent"
        *ngIf="permissionsService.isCustomerRetagAllowed">
        {{'COMMON.RETAG' | translate}}
      </button>
      <div class="recall-div" *ngIf="
          permissionsService.isCustomerRecallAssignedAllowed ||
          permissionsService.isCustomerRecallValidatedAllowed
        ">
        <button class="btn btn-header recall-button" style="color: black" (click)="showRecallMenu = !showRecallMenu">
          <span class="recall-span">{{'COMMON.RECALL' | translate}}</span>
        </button>
        <div *ngIf="showRecallMenu" class="recall-options">
          <div class="recall-type" [ngClass]="[
              !recallAssignedAllowed
                ? 'recall-type-disabled'
                : 'recall-type-enabled'
            ]" (click)="
              recallAssignedAllowed
                ? recallAssigned()
                : null
            ">
            <span>{{'COMMON.ASSIGNED_TASK' | translate}}</span>
          </div>
          <div class="recall-type" [ngClass]="[
              !recallValidatedAllowed
                ? 'recall-type-disabled'
                : 'recall-type-enabled'
            ]" (click)="
              recallValidatedAllowed
                ? recallValidation()
                : null
            ">
            <span>{{'COMMON.VALIDATED_TASK' | translate}}</span>
          </div>
        </div>
      </div>

      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#updateStatus"
        [disabled]="disableUpdateStatusButton()" (click)="updateStatusClicked = true"
        *ngIf="permissionsService.isCustomerApproveRejectAllowed">
        {{'COMMON.UPDATE_STATUS' | translate}}
      </button>
      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#auditReview"
        [disabled]="disableAuditReviewButton()" *ngIf="permissionsService.isCustomerAuditReviewAllowed">
        {{'COMMON.FIELD_AUDIT' | translate}}
      </button>
      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#review" [disabled]="disableReviewButton()"
        *ngIf="permissionsService.isCustomerReviewAllowed">
        {{'COMMON.REVIEW_BUTTON' | translate}}
      </button>
      <button class="btn btn-header" data-bs-toggle="modal"
        (click)="getMobileUsers(); setModalType(AssetAssignType.Assigned);" data-bs-target="#assignToFieldAgent"
        *ngIf="permissionsService.isCustomerAssignAllowed">
        {{'COMMON.ASSIGN_AGENT' | translate}}
      </button>
      <button class="btn btn-header" *ngIf="!editEnabled && permissionsService.isCustomerCreateEditAllowed"
        (click)="edit()">
        {{'COMMON.EDIT' | translate}}
      </button>
      <button class="btn btn-primary" *ngIf="editEnabled" (click)="openEditModal()">
        {{'COMMON.SAVE' | translate}}
      </button>
    </div>
  </div>
  <div class="edit-customers-body">
    <div class="main-col">
      <div class="card container">
        <div class="row">
          <div class="col-5">{{'COMMON.SLRN' | translate}}</div>
          <div class="col-7">{{ customer.building.slrn | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.BU.SINGLE' | translate}}</div>
          <div class="col-7">{{hasCimDataIntegration ? customer.geographicalRegionName : customer.area?.regionName | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.UT.SINGLE' | translate}}</div>
          <div class="col-7">{{hasCimDataIntegration ? customer.subGeographicalRegionName : customer.area?.name | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.CUSTOMER_ADDRESS' | translate}}</div>
          <div class="col-7">
            {{ customer.address | hasValue }}
          </div>
        </div>
        <div class="row" *ngIf="permissionsService.isCustomerElectricalAddressCodeAllowed">
          <div (click)="switchElectricalAddressFormat()" class="col-5 property-code-switch">
            {{ (isCinEnabled ? 'COMMON.MBC_DETAILS.CIN' : 'COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS') | translate }}</div>
          <div *ngIf="!isElectricalAddressLong" class="col-7">
            {{ customer.electricalAddress | hasValue }}
          </div>
          <div *ngIf="isElectricalAddressLong" class="col-7">
            {{ customer.electricalAddressLong | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.PHYSICAL_ADDRESS' | translate}}</div>
          <div class="col-7">
            {{ customer.physicalAddress | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.CLOSEST_LANDMARK' | translate}}</div>
          <div class="col-7">
            {{ customer.building?.closestLandmark | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.ACCOUNT_NO' | translate}}</div>
          <div class="col-7">
            {{ customer.accountNumber | hasValue }}
          </div>
          <!-- <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.accountNumber" /> -->
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.BUILDING_OWNER' | translate}}</div>

          <div *ngIf="!editEnabled" class="col-7">
            {{ customer.buildingOwner | hasValue }}
          </div>
          <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.buildingOwner" />
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.CUSTOMER_NAME' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">
            {{ customer.tenantName | hasValue }}
          </div>
          <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.tenantName" />
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.BUILDING_STRUCTURE.NAME' | translate}}</div>
          <div class="col-7">
            {{ customer.building.buildingStructure | enumTranslate | translate }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.BUILDING_DEVELOPMENT.NAME' | translate}}</div>
          <div class="col-7">
            {{ customer.building.buildingDevelopmentStage | enumTranslate | translate }}
          </div>
        </div>

        <div class="row conn-assets">
          <div class="col-5">{{ 'COMMON.POLE.CONNECTED_LT_POLE' | translate }}</div>
          <div class="col-7 d-flex align-items-center justify-content-end">
            {{ customer.building.poleSlrn | hasValue }}
            <img *ngIf="customer.building?.poleId" class="ml-3" (click)="viewConnectedAssets(1)" title="View"
              src="assets/icons/angles-right.svg">
          </div>
        </div>
        <div class="row">
          <div class="col-4">{{'COMMON.MBC_DETAILS.FEEDER_NAME' | translate}}</div>

          <div class="col-8">
            {{ hasCimDataIntegration ? customer.substation?.feederName : customer.dt?.feeder?.name | hasValue }}
          </div>
        </div>

        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate}}</div>
          <div class="col-7">{{ hasCimDataIntegration ? customer.substation?.feederNumber : customer.dt?.feeder?.number | hasValue
            }}</div>
        </div>
        <div class="row">
          <div class="col-4">{{'COMMON.DT_NAME' | translate}}</div>
          <div class="col-8">
            {{ hasCimDataIntegration ? customer.substation?.dtName : customer.dt?.name | hasValue }}
          </div>

        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.DT_NUMBER' | translate}}</div>
          <div class="col-7">{{ hasCimDataIntegration ? customer.substation?.dtNumber : customer.dt?.number | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.NUMBER_IN_HOUSE' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">
            {{ customer?.numberOfHouseholds | hasValue }}
          </div>
          <input *ngIf="editEnabled" class="col-7" type="number" [(ngModel)]="customer.numberOfHouseholds"
            pattern="[0-9]+" />
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.CONNECTED_SERVICE_WIRE' | translate}}</div>
          <div class="col-7">
            {{ customer?.connectedServiceWire | hasValue }}
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.TYPE_OF_CONNECTION' | translate }}</div>
          <div class="col-7">{{ customer?.typeOfConnection | enumTranslate | translate }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.USE_OF_PREMISES' | translate}}</div>
          <div class="col-7">{{ customer?.buildingType?.toString() | enumTranslate | translate }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.PREMISE_TYPE' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ customer?.permiseType | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
            <select class="form-control" [(ngModel)]="customer.permiseType" (change)="selectPermiseType()">
              <option *ngFor="let option of permiseOptions" [ngValue]="option">
                {{ option }}
              </option>
            </select>
          </div>

        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.PREMISE_CATEGORY' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ customer?.permiseCategory | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
            <select class="form-control" [(ngModel)]="customer.permiseCategory">
              <option *ngFor="let option of permiseCategoryOptions" [ngValue]="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.ACTIVITY' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ customer?.activity | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
            <select class="form-control" [(ngModel)]="customer.activity" (change)="selectActivity()">
              <option *ngFor="let option of activityOptions" [ngValue]="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.SUB_ACTIVITY' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ customer?.subActivity | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
            <select class="form-control" [(ngModel)]="customer.subActivity">
              <option *ngFor="let option of subactivityOptions" [ngValue]="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.NEIGHBORHOOD' | translate}}</div>
          <div class="col-7" *ngIf="!editEnabled">{{ customer?.neighborhood | enumTranslate | translate }}</div>
          <div *ngIf="editEnabled" class="col-7">
            <select class="form-control" [(ngModel)]="customer.neighborhood">
              <option *ngFor="let option of neighborhoodOptions" [ngValue]="neighborhood[option.key]">
                {{ option.value }}
              </option>
            </select>
          </div>
        </div>
        <div class="row" *ngIf="customer.buildingType.toString() == 'Residential' ">
          <div class="col-5">{{'COMMON.MBC_DETAILS.NUMBER_OF_ROOMS' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ customer?.numberOfRooms | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
            <select class="form-control" [(ngModel)]="customer.numberOfRooms">
              <option *ngFor="let option of numberOfRoomsOptions" [ngValue]="option">
                {{ option }}
              </option>
            </select>
          </div>

        </div>
        <div *ngIf="customer.propertyCode != ''" class="row">
          <div (click)="switchPropertyCodeFormat()" class="col-5 property-code-switch">
            {{'COMMON.MBC_DETAILS.PROPERTY_CODE' | translate}}</div>
          <div *ngIf="!isPropertyCodeShort" class="col-7">{{ customer.propertyCode | hasValue }}</div>
          <div *ngIf="isPropertyCodeShort" class="col-7">{{ customer.propertyCodeShort | hasValue }}</div>
        </div>
      </div>
      <div class="card container" *ngIf="permissionsService.hasDashboardConfigEnergySources && countOfEnergySource">
        <div class="row">
          <div class="col-5 header-title">
            {{'COMMON.CUSTOMER.ENERGY_SOURCE.CONNECTED' | translate}}
            <span class="energy-source-count">{{
              currentEnergySourcePage + 1
              }}</span>
          </div>

          <div class="col-5">
            <hr />
          </div>
          <div class="col-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none"
              (click)="previousEnergySource()">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M18.332 22C20.5411 22 22.332 20.2091 22.332 18V4C22.332 1.79086 20.5411 0 18.332 0H4.33203C2.12289 0 0.332031 1.79086 0.332031 4V18C0.332031 20.2091 2.12289 22 4.33203 22H18.332ZM4.33203 20H18.332C19.4366 20 20.332 19.1046 20.332 18V4C20.332 2.89543 19.4366 2 18.332 2H4.33203C3.22746 2 2.33203 2.89543 2.33203 4V18C2.33203 19.1046 3.22746 20 4.33203 20ZM9.86593 15.2427L11.2801 13.8285L9.45173 12H16.9888V10H9.45173L11.2801 8.17161L9.86593 6.7574L5.62329 11L9.86593 15.2427Z"
                fill="#00423E" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none"
              (click)="nextEnergySource()">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M4.33203 22C2.12289 22 0.332031 20.2091 0.332031 18V4C0.332031 1.79086 2.12289 0 4.33203 0H18.332C20.5411 0 22.332 1.79086 22.332 4V18C22.332 20.2091 20.5411 22 18.332 22H4.33203ZM18.332 20H4.33203C3.22746 20 2.33203 19.1046 2.33203 18V4C2.33203 2.89543 3.22746 2 4.33203 2H18.332C19.4366 2 20.332 2.89543 20.332 4V18C20.332 19.1046 19.4366 20 18.332 20ZM12.7981 15.2427L11.3839 13.8285L13.2123 12H5.67521V10H13.2123L11.3839 8.17161L12.7981 6.7574L17.0407 11L12.7981 15.2427Z"
                fill="#00423E" />
            </svg>
          </div>
        </div>

        <div *ngIf="currentEnergySource">
          <div class="row">
            <div class="col-4">{{'COMMON.CUSTOMER.ENERGY_SOURCE.SINGLE' | translate}}</div>
            <div class="col-8">{{ currentEnergySource.energySourceType?.toString() | enumTranslate | translate }}</div>
          </div>
          <div class="row">
            <div class="col-4">{{'COMMON.MBC_DETAILS.METER_STATUS' | translate}}</div>
            <div class="col-8">{{ currentEnergySource.meterStatus?.toString() | enumTranslate | translate }}</div>
          </div>
          <div class="row">
            <div class="col-4">{{'COMMON.MBC_DETAILS.METER_CONDITION' | translate}}</div>
            <div class="col-8">{{ currentEnergySource.meterCondition?.toString() | enumTranslate | translate }}</div>
          </div>
          <div class="row">
            <div class="col-4">{{'COMMON.MBC_DETAILS.METER_TYPE.SINGLE' | translate}}</div>
            <div class="col-8">{{ currentEnergySource.meterBrand | hasValue }}</div>
          </div>
          <div class="row">
            <div class="col-4">{{'COMMON.MBC_DETAILS.METER_NO' | translate}}</div>
            <div class="col-8">{{ currentEnergySource.meterNumber | hasValue }}</div>
          </div>
          <ng-container *ngIf="currentEnergySource.energySourceType?.toString() == 'Solar'">
            <div class="row">
              <div class="col-4">{{'COMMON.CUSTOMER.ENERGY_SOURCE.SOLAR_CAPACITY' | translate}}</div>
              <div class="col-8">{{ currentEnergySource.solarInfo?.solarCapacity | hasValue }}</div>
            </div>
            <div class="row">
              <div class="col-4">{{'COMMON.CUSTOMER.ENERGY_SOURCE.INVERTER_OEM' | translate}}</div>
              <div class="col-8">{{ currentEnergySource.solarInfo?.inverterOem | hasValue }}</div>
            </div>
            <div class="row">
              <div class="col-4">{{'COMMON.CUSTOMER.ENERGY_SOURCE.STORAGE_CAPACITY' | translate}}</div>
              <div class="col-8">{{ currentEnergySource.solarInfo?.storageCapacity | hasValue }}</div>
            </div>
            <div class="row">
              <div class="col-4">{{'COMMON.CUSTOMER.ENERGY_SOURCE.INVERTER_CAPACITY' | translate}}</div>
              <div class="col-8">{{ currentEnergySource.solarInfo?.inverterCapacity | hasValue }}</div>
            </div>
          </ng-container>
        </div>
      </div>
      <app-history-tracker [histories]="customer.customerHistories"></app-history-tracker>

      <div *ngIf="isDataQuality && customer.dataValidationReview != null && customer.dataValidationReview.length > 0"
        class="history-card container">
        <h4 style="text-align: center">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h4>
        <div class="row" *ngFor="let dq of customer.dataValidationReview">
          <div class="col-5">{{ dq.key }}</div>
          <div *ngIf="dq.key != 'Reason for rejection'" class="col-7">
            {{ dq.value| hasValue }}
          </div>
          <div *ngIf="dq.key == 'Reason for rejection'" class="col-7">
            <a data-bs-toggle="modal" data-bs-target="#rejectionReason">view</a>
          </div>
        </div>
      </div>
    </div>
    <div class="card container main-col">
      <div class="row">
        <div class="col-5">{{ 'COMMON.MBC_DETAILS.METER_TYPE.SINGLE' | translate }}</div>

        <div *ngIf="!editEnabled" class="col-7">
          {{ customer?.meter?.meterType?.name | hasValue }}
        </div>
        <div *ngIf="editEnabled" class="col-7">
          <select class="select-dropdown form-control" [(ngModel)]="customer.meterTypeId">
            <option *ngFor="let option of meterTypeOptions" [ngValue]="option.key">
              {{ option.value }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{ 'COMMON.MBC_DETAILS.METER_NO' | translate }}</div>
        <div *ngIf="!editEnabled" class="col-7">
          {{ customer?.meter?.number | hasValue }}
        </div>
        <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.meter.number" />
      </div>
      <div class="row">
        <div class="col-5">{{ 'COMMON.MBC_DETAILS.OLD_METER_NO' | translate }}</div>
        <div *ngIf="!editEnabled" class="col-7">
          {{ customer?.oldMeterNumber | hasValue }}
        </div>
        <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.meter.number" />
      </div>
      <div class="row" *ngIf="isSPNFieldVisible">
        <div class="col-5">{{ 'COMMON.CONTRACT_NUMBER' | translate }}</div>
        <div class="col-7">{{ customer?.contractNumber | hasValue }}</div>
      </div>

      <div class="row" *ngIf="isServiceTypeFieldVisible">
        <div class="col-5">{{'COMMON.SERVICE_TYPE.TITLE' | translate}}</div>
        <div class="col-7">{{ customer?.serviceType | enumTranslate | translate }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{ 'COMMON.MBC_DETAILS.CUSTOMER_TYPE' | translate }}</div>
        <div *ngIf="!editEnabled" class="col-7">
          {{ customer?.customerType | enumTranslate | translate }}
        </div>
        <div *ngIf="editEnabled" class="col-7">
          <select class="select-dropdown form-control" [(ngModel)]="customer.customerType">
            <option *ngFor="let option of customerTypeOptions" [ngValue]="option.key">
              {{ option.value }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-5">{{ 'COMMON.SLT_STATUS.SINGLE' | hasValue | translate }}</div>
        <div *ngIf="!editEnabled" class="col-7">
          {{ customer?.sltStatus?.value?.toString() | hasValue }}
        </div>
        <div *ngIf="editEnabled" class="col-7">
          <select class="select-dropdown form-control" [(ngModel)]="selectedSltStatus.key">
            <option *ngFor="let option of sltOptions" [ngValue]="option.key">
              {{ option.value }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.TARIFF_CLASS' | translate}}</div>
        <div class="col-7">{{ customer?.tariffClass | hasValue }}</div>
      </div>
      <div class="row" *ngIf="isActualTariffFieldVisible">
        <div class="col-5">{{'COMMON.MBC_DETAILS.REC_ACT_TARIFF_CLASS' | translate}}</div>
        <div class="col-7">{{ customer?.actualTariffClass | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.CLIENT_TYPE' | translate}}</div>
        <div *ngIf="!editEnabled" class="col-7">{{ customer?.clientType | enumTranslate | translate }}</div>
        <div *ngIf="editEnabled" class="col-7">
          <select class="select-dropdown form-control" [(ngModel)]="customer.clientType">
            <option *ngFor="let option of clientTypeOptions" [ngValue]="option.key">
              {{ option.value }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.METER_STATUS' | translate}}</div>
        <div class="col-7">{{ customer?.meterStatus | enumTranslate | translate }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.METER_CONDITION' | translate}}</div>
        <div class="col-7">{{ customer?.meterCondition?.toString() | enumTranslate | translate }}</div>
      </div>
      <div class="row" *ngIf="isMeterSlrnFieldVisible">
        <div class="col-5">{{'COMMON.MBC_DETAILS.METER_SLRN' | translate}}</div>
        <div class="col-7">{{ customer?.meterSlrn | hasValue }}</div>
      </div>
      <div class="row" *ngIf="isFrmMeterVisible">
        <div class="col-5">{{'COMMON.MBC_DETAILS.FRM_METER_NO' | translate}}</div>
        <div class="col-7">{{ customer?.frmMeterNumber | hasValue }}</div>
      </div>
      <div class="row" *ngIf="isInstallationDateVisible">
        <div class="col-5">{{'COMMON.MBC_DETAILS.INSTALLATION_DATE' | translate}}</div>
        <div class="col-7">{{ customer?.installationDate| date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
      </div>
      <div class="row" *ngIf="isReplacementDateVisible">
        <div class="col-5">{{'COMMON.MBC_DETAILS.REPLACEMENT_DATE' | translate}}</div>
        <div class="col-7">{{ customer?.replacementDate| date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.ID_CARD_NUM' | translate}}</div>
        <div class="col-7" *ngIf="!editEnabled">{{ customer?.cardNumber | hasValue }}</div>
        <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.cardNumber" />
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.PHONE_NO' | translate}}</div>
        <div *ngIf="!editEnabled" class="col-7">
          {{ customer.phoneNumber | hasValue }}
        </div>
        <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.phoneNumber" pattern="[0-9]+" />
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.EMAIL' | translate}}</div>
        <div *ngIf="!editEnabled" class="col-7">
          {{ customer?.email | hasValue }}
        </div>
        <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.email" type="email" />
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.BUILDING_CREATION_DATE' | translate}}</div>
        <div class="col-7">
          {{ customer.building.creationDate | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.DATE_TYPE.TAGGED' | translate}}</div>
        <div class="col-7">
          {{ customer.taggedDate | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.USER.TYPE.FIRST_CAPTURED' | translate}}</div>
        <div class="col-7">
          {{ customer.firstCaptureUser | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.LAST_UPDATED' | translate}}</div>
        <div class="col-7">
          {{ customer.lastUpdateUser | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.UPDATED_DATE' | translate}}</div>
        <div class="col-7">
          {{customer.lastUpdateTime| date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue}}
        </div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.USER.TYPE.REASSIGNED' | translate}}</div>
        <div class="col-7">{{ customer.building.reassignedBy | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.ASSIGNED' | translate}}</div>
        <div class="col-7">{{ customer.building.assignedUser | hasValue }}</div>
      </div>
      <div class="row" *ngIf="permissionsService.isValidationStatusAllowed">
        <div class="col-5">{{'COMMON.USER.TYPE.VALIDATED' | translate}}</div>
        <div class="col-7">{{ customer.validatedBy | hasValue }}</div>
      </div>
      <div class="row" *ngIf="permissionsService.isValidationStatusAllowed">
        <div class="col-5">{{'COMMON.DATE_TYPE.VALIDATED' | translate}}</div>
        <div class="col-7">
          {{customer.validatedDate| date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue}}
        </div>
      </div>
      <div class="row" *ngIf="permissionsService.isAuditStatusAllowed">
        <div class="col-5">{{'COMMON.MBC_DETAILS.AUDITED_STATUS' | translate}}</div>
        <div class="col-7">{{ customer.isAudited | enumTranslate:'Audit' | translate }}</div>
      </div>
      <div class="row" *ngIf="permissionsService.isAuditStatusAllowed">
        <div class="col-5">{{'COMMON.USER.TYPE.AUDITED' | translate}}</div>
        <div class="col-7">{{ customer.auditedBy | hasValue }}</div>
      </div>
      <div class="row" *ngIf="permissionsService.isAuditStatusAllowed">
        <div class="col-5">{{'COMMON.MBC_DETAILS.AUDITED_DATE' | translate}}</div>
        <div class="col-7">
          {{customer.auditedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue}}
        </div>
      </div>
      <div *ngIf="permissionsService.isValidationStatusAllowed" class="row">
        <div class="col-5">{{'COMMON.VALIDATION_STATUS' | translate}}</div>
        <div class="col-7"> {{ getCustomerStatusTranslationKey() | enumTranslate | translate }} </div>
      </div>
      <div class="row" *ngIf="permissionsService.isReviewStatusAllowed">
        <div class="col-5">{{'COMMON.MBC_DETAILS.REVIEW_STATUS' | translate}}</div>
        <div class="col-7">{{ customer.isReviewed | enumTranslate:'Review' | translate }}</div>
      </div>
      <div class="row" *ngIf="permissionsService.isReviewStatusAllowed">
        <div class="col-5">{{'COMMON.USER.TYPE.REVIEWED' | translate}}</div>
        <div class="col-7">{{ customer.reviewedBy | hasValue }}</div>
      </div>
      <div class="row" *ngIf="permissionsService.isReviewStatusAllowed">
        <div class="col-5">{{'COMMON.MBC_DETAILS.REVIEW_DATE' | translate}}</div>
        <div class="col-7">
          {{customer.reviewDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue}}
        </div>
      </div>
      <ng-container *ngIf="permissionsService.hasDashboardConfigBillingIntegration">
        <div class="row">
          <div class="col-8">{{'COMMON.MBC_DETAILS.PAYMENT_AND_VEND' | translate}}</div>
          <div class="col-4 view-payment-info" (click)="getPaymentAndVendFromBilling()"><a data-bs-toggle="modal"
              data-bs-target="#paymentInfo">{{'COMMON.VIEW' | translate }}</a></div>
        </div>
      </ng-container>

      <div class="row" *ngIf="isGhanaPostFieldsVisible">
        <div class="col-5">{{'COMMON.GHANA_POST_CODE' | translate}}</div>
        <div class="col-7">{{ customer.ghanaPostGps | hasValue }}</div>
      </div>
      <div class="row" *ngIf="customer.postCodeException && isGhanaPostFieldsVisible">
        <div class="col-5">{{ 'COMMON.GHANA_POST_CODE_EXC' | translate }}</div>
        <div class="col-7">{{ customer.postCodeException | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.GEO_LOCATION' | translate}}</div>
        <div class="locationText col-6">
          {{ customer.building.latitude }}, {{ customer.building.longitude }}
        </div>
        <div class="location col-1" (click)="isMapVisible = !isMapVisible">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" data-bs-toggle="modal"
            data-bs-target="#showMap">
            <path
              d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
              fill="#026962" />
          </svg>
        </div>
      </div>
      <div class="row" *ngIf="isGeoCodeVisible">
        <div class="col-5">{{ 'COMMON.GEO_CODE' | translate }}</div>
        <div class="col-7">{{ customer.geoCode | hasValue }}</div>
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.CUSTOMER_INSPECTION' | translate}}</div>
        <div *ngIf="!editEnabled" class="col-7">
          {{ customer?.customerInspectionConclusion | hasValue }}
        </div>
        <input *ngIf="editEnabled" class="col-7" [(ngModel)]="customer.customerInspectionConclusion" />
      </div>
      <div class="row">
        <div class="col-5">{{'COMMON.MBC_DETAILS.REMARKS' | translate}}</div>
        <div class="col-7">
          {{ customer.remarksAndRecommendations | hasValue }}
        </div>
      </div>
    </div>
    <div class="image-container main-col">
      <div class="card container">
        <div>{{'COMMON.PICTURES.FRONT' | translate}}</div>

        <div class="images-list">
          <app-image-section *ngFor="let index of [0,1,2]" [image]="getFrontViewImage(index)" [index]="index"
            [imageType]="ImageType.Frontview" [editEnabled]="editEnabled"
            [permission]="permissionsService.isCustomerCreateEditAllowed" [inputId]="'fileFw' + index"
            (imageClick)="showImage(ImageType.Frontview, index)" (fileChange)="fileBrowserHandler($event)">
          </app-image-section>
        </div>
      </div>
      <div class="card container">
        <div>{{'COMMON.PICTURES.MOUNTED_TAG' | translate}}</div>
        <div class="images-list single-image-list">
          <app-image-section [image]="getBuildingMountedImage()" [index]="0" [imageType]="ImageType.MountedTag"
            [editEnabled]="editEnabled" [inputId]="'fileMounted' + 0"
            [permission]="permissionsService.isCustomerCreateEditAllowed" (imageClick)="showImage(ImageType.MountedTag)"
            (fileChange)="fileBrowserHandler($event)">
          </app-image-section>
        </div>
      </div>
      <div class="card container">
        <div class="image-section row">
          <div class="image-item col-4">
            <div class="image-title">{{ 'COMMON.PICTURES.BILL' | translate }}</div>

            <app-image-section [image]="customer.billImageUrl" [index]="0" [imageType]="ImageType.Bill"
              [editEnabled]="editEnabled" [inputId]="'fileBill' + 0"
              [permission]="permissionsService.isCustomerCreateEditAllowed" (imageClick)="showImage(ImageType.Bill)"
              (fileChange)="fileBrowserHandler($event)">
            </app-image-section>

          </div>
          <div class="image-item col-4">
            <div class="image-title">{{ 'COMMON.PICTURES.ID_CARD' | translate }}</div>

            <app-image-section [image]="customer.cardImageUrl" [index]="0" [imageType]="ImageType.Card"
              [editEnabled]="editEnabled" [inputId]="'fileCard' + 0"
              [permission]="permissionsService.isCustomerCreateEditAllowed" (imageClick)="showImage(ImageType.Card)"
              (fileChange)="fileBrowserHandler($event)">
            </app-image-section>

          </div>
          <div *ngIf="isCustomerMountedTagVisible" class="image-item col-4">
            <div class="image-title">{{ 'COMMON.PICTURES.CUSTOMER_TAG' | translate }}</div>

            <app-image-section [image]="customer.meterImageUrl" [index]="0" [imageType]="ImageType.Meter"
              [editEnabled]="editEnabled" [inputId]="'fileCustomerTag' + 0"
              [permission]="permissionsService.isCustomerCreateEditAllowed" (imageClick)="showImage(ImageType.Meter)"
              (fileChange)="fileBrowserHandler($event)">
            </app-image-section>

          </div>

          <div class="image-item col-4" *ngIf="isImageMeterFieldVisible">
            <div class="image-title">{{ 'COMMON.PICTURES.METER_NUMBER' | translate }}</div>
            <app-image-section [image]="customer.meterNumberImageUrl" [index]="0" [imageType]="ImageType.MeterNumber"
              [editEnabled]="editEnabled" [inputId]="'fileMeter2' + 0"
              [permission]="permissionsService.isCustomerCreateEditAllowed"
              (imageClick)="showImage(ImageType.MeterNumber)" (fileChange)="fileBrowserHandler($event)">
            </app-image-section>
          </div>
          <div class="image-item col-4" *ngIf="isBackViewPictureFieldVisible">
            <div class="image-title">{{ 'COMMON.PICTURES.CARD_BACK' | translate }}</div>

            <app-image-section [image]="customer.backCardViewImageUrl" [index]="0"
              [imageType]="ImageType.CardBackViewImage" [editEnabled]="editEnabled" [inputId]="'fileCardBack' + 0"
              [permission]="permissionsService.isCustomerCreateEditAllowed"
              (imageClick)="showImage(ImageType.CardBackViewImage)" (fileChange)="fileBrowserHandler($event)">
            </app-image-section>

          </div>
          <div class="image-item col-4" *ngIf="isNewMeterPictureVisible && customer.newMeterPictureUrl">
            <div class="image-title">{{ 'COMMON.PICTURES.NEW_METER_PICTURE' | translate }}</div>

            <app-image-section [image]="customer.newMeterPictureUrl" [index]="0"
              [imageType]="ImageType.MeterReplacementReadingImage" [editEnabled]="editEnabled"
              [inputId]="'fileNewMeter' + 0" [permission]="permissionsService.isCustomerCreateEditAllowed"
              (imageClick)="showImage(ImageType.MeterReplacementReadingImage)"
              (fileChange)="fileBrowserHandler($event)">
            </app-image-section>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true"
    (hidden.bs.modal)="onModalAssignFade()">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 *ngIf="assetAssignType == AssetAssignType.Assigned" class="modal-title">{{'COMMON.ASSIGN_AGENT' |
            translate}}</h5>
          <h5 *ngIf="assetAssignType == AssetAssignType.Retagged" class="modal-title">{{'COMMON.RETAG_TASK' |
            translate}}</h5>
          <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            {{'COMMON.CANCEL' | translate}}
          </button>
        </div>
        <div class="modal-body">
          <div class="form-floating form-item">
            <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
              class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }"
              id="floatingInput" (ngModelChange)="filterMobileUsers()" (click)="openDropdown()" placeholder=" " />
            <label for="floatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

            <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
              <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
                *ngFor="let u of mobileUsers">
                {{ u.fullName }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="assignTask()">
            <span *ngIf="assetAssignType == AssetAssignType.Assigned">{{'COMMON.ASSIGN_TASK' | translate}}</span>
            <span *ngIf="assetAssignType == AssetAssignType.Retagged">{{'COMMON.RETAG_TASK' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
    (shown.bs.modal)="onModalOpen()">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-image">
        <div class="modal-body modal-body-image">
          <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
            <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url" [thumbImage]="selectedImage?.url"
              [magnification]="3">
            </lib-ngx-image-zoom>
          </div>
          <div class="rotate-div">
            <button class="btn btn-primary left-button" (click)="rotateLeft()">
              &lt;
            </button>
            <button class="btn btn-primary right-button" (click)="rotateRight()">
              &gt;
            </button>
          </div>
          <app-image-geo-info [image]="selectedImage"
            (mapClicked)="isImageMapVisible = !isImageMapVisible"></app-image-geo-info>
        </div>
      </div>
    </div>
  </div>
  <div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" #closeAddModal class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-building-map [setMapVisibility]="isMapVisible" [longitude]="longitude"
            [latitude]="latitude"></app-building-map>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h5>
          <button type="button" #closeDQModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            {{'COMMON.CANCEL' | translate}}
          </button>
        </div>
        <div class="modal-body">
          <app-data-quality (closeModal)="cancelModal($event)" (closeRedirectModal)="closeRedirectModal()"
            assetType="Customer" [assetId]="customerId" [areaId]="customer.area.id"
            *ngIf="updateStatusClicked"></app-data-quality>
        </div>
      </div>
    </div>
  </div>
  <app-audit-review-customer (closeModal)="cancel($event)" assetType="Customer"
    [assetId]="customerId"></app-audit-review-customer>

  <div class="modal" id="rejectionReason" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.REASON_FOR_REJECT' | translate}}</h5>
        </div>
        <div class="p-4">
          {{ modalRejectionReason }}
        </div>
        <button type="button" #closeRejectionReason class="btn btn-primary w-50 mx-auto" data-bs-dismiss="modal"
          aria-label="Close">
          {{'COMMON.CLOSE' | translate}}
        </button>
      </div>
    </div>
  </div>

  <div class="modal" id="paymentInfo" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.MBC_DETAILS.PAYMENT_AND_VEND' | translate}}</h5>
        </div>
        <div class="row" *ngIf="customer.customerType?.toString() == 'Prepaid'">
          <div class="col-5">{{'COMMON.MBC_DETAILS.LAST_VEND_AMOUNT' | translate}}</div>
          <div class="col-7">{{ customer?.lastVendAmount | hasValue }}</div>
        </div>
        <div class="row" *ngIf="customer.customerType?.toString() == 'Prepaid'">
          <div class="col-5">{{'COMMON.MBC_DETAILS.LAST_VEND_DATE' | translate}}</div>
          <div class="col-7">{{ customer?.lastVendDate | hasValue }}</div>
        </div>
        <div class="row" *ngIf="customer.customerType?.toString() == 'Postpaid'">
          <div class="col-5">{{'COMMON.MBC_DETAILS.LAST_PAYMENT_AMOUNT' | translate}}</div>
          <div class="col-7">{{ customer?.lastPaymentAmount | hasValue }}</div>
        </div>
        <div class="row" *ngIf="customer.customerType?.toString() == 'Postpaid'">
          <div class="col-5">{{'COMMON.MBC_DETAILS.LAST_PAYMENT_DATE' | translate}}</div>
          <div class="col-7">{{ customer?.lastPaymentDate | hasValue }}</div>
        </div>
        <div class="row" *ngIf="customer.customerType?.toString() == 'Postpaid'">
          <div class="col-5">{{'COMMON.MBC_DETAILS.CURRENT_DEBT' | translate}}</div>
          <div class="col-7">{{ customer?.currentDebtBalance | hasValue }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="review" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.REVIEW' | translate}}</h5>
          <button type="button" #closeReviewModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
            {{'COMMON.CANCEL' | translate}}
          </button>
        </div>
        <app-review (closeModal)="cancelReviewModal($event)" assetType="Customer" [assetId]="customerId"></app-review>
      </div>
    </div>
  </div>

  <button class="btn btn-primary" #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history"
    hidden></button>
  <app-history (update)="updateHistory($event)"></app-history>